import React from 'react';

const LandingPrimaryButton = ({children, additionalclasses, onClick}) => {
    return (
        <button onClick={onClick} className={`h-[43px] lg:h-[49px] grid items-center justify-center px-[37px] lg:px-[27px] bg-white-50 w-fit rounded-[7.7px] lg:rounded-[14px] text-grey-900 text-[16px] leading-[33.6px] m-auto ${additionalclasses}`}>
            {children}
        </button>
    );
};

export default LandingPrimaryButton;